module.exports = __webpack_public_path__ + "static/img/audio-pause.97b3c121.png";